const map = {
	"./en.json": [
		5596,
		[
			5596
		]
	],
	"./es.json": [
		5355,
		[
			5355
		]
	],
	"./fr.json": [
		7015,
		[
			7015
		]
	],
	"./zh.json": [
		2093,
		[
			2093
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6446;
module.exports = webpackAsyncContext;